var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-card-group"},[_c('h4',{staticClass:"v-card-group-title"},[_vm._t("title"),_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }